import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["data"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery } from '@tanstack/react-query';
import config from 'utils/config';
import { fetchCachedMindsetSettings } from 'utils/mindset/fetchCachedMindsetSettings';
import userProfileKeys from './queryKeys';
function useFetchUserMindsetSettings() {
  var _useQuery = useQuery({
      queryKey: userProfileKeys.mindsetAgent,
      queryFn: function queryFn() {
        return fetchCachedMindsetSettings();
      },
      staleTime: 5 * 60 * 1000,
      enabled: !!config.mindsetAppUid
    }),
    data = _useQuery.data,
    result = _objectWithoutProperties(_useQuery, _excluded);
  return _objectSpread({
    mindsetAgent: data,
    hasMindsetAgent: Boolean(data === null || data === void 0 ? void 0 : data.agentUid),
    hasMindsetApp: Boolean(data === null || data === void 0 ? void 0 : data.appUid)
  }, result);
}
export default useFetchUserMindsetSettings;